/* eslint-disable react-refresh/only-export-components */
import React, { useContext } from 'react';
import { notification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';

const Context = React.createContext<NotificationInstance>({
  destroy: (_key: React.Key) => {},
  error: () => {},
  info: () => {},
  open: () => {},
  success: () => {},
  warning: () => {},
});

const NotificationProvider = ({ children }: { children: React.ReactNode }) => {
  const [api, contextHolder] = notification.useNotification();

  return (
    <Context.Provider value={api}>
      {contextHolder}
      {children}
    </Context.Provider>
  );
};

export const useNotification = () => useContext(Context);

export default NotificationProvider;
